<template>
  <div>
    <div class="article-search__wrapper">
      <div class="article-search__input">
        <SearchOnPageInput v-model="preQuery" />
      </div>

      <div class="article-search__filters">
        <vue-select
          :options="genres"
          label="name"
          item-value="name"
          v-model="selectedGenre"
          @input="doSearch"
          style="min-width: 7em"
          class="cmf-select cmf-select-genres"
          placeholder="Genre"
          :components="{ OpenIndicator, Deselect }"
        ></vue-select>
        <vue-select
          :options="schools"
          label="name"
          item-value="name"
          v-model="selectedSchool"
          @input="doSearch"
          style="min-width: 7.75em"
          class="cmf-select cmf-select-schools"
          placeholder="School"
          :components="{ OpenIndicator, Deselect }"
        ></vue-select>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import OpenIndicator from "./VueSelect/OpenIndicator.vue";
import Deselect from "./VueSelect/Deselect.vue";
export default {
  props: {
    genres: Array,
    schools: Array
  },
  data() {
    return {
      query: "",
      preQuery: "",
      selectedGenre: undefined,
      selectedSchool: undefined,
      results: {},
      OpenIndicator: OpenIndicator,
      Deselect: Deselect
    };
  },
  methods: {
    doSearch() {
      setTimeout(() => {
        const searchParams = {
          pageSlug: "jury",
          query: this.query.trim(),
          genre: this.selectedGenre ? this.selectedGenre.name : undefined,
          school: this.selectedSchool ? this.selectedSchool.name : undefined
        };
        this.$root.$emit("article-search", searchParams);
      }, 50);
    }
  },
  watch: {
    query() {
      this.doSearch();
    },
    preQuery: _.debounce(function() {
      this.query = this.preQuery;
    }, 100)
  }
};
</script>

<style lang="scss" scoped>
.article-search {
  &__wrapper {
    margin: 80px 120px 0;
    padding: 16px 25px;
    background: white;
    box-shadow: 0px 2px 10px rgba(241, 93, 59, 0.5);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media screen and (max-width: 960px) {
      margin: 40px 20px 0;
      padding: 16px 20px;
      flex-direction: column;
      align-items: stretch;
    }
  }
  &__input {
    flex-basis: 455px;
    @media screen and (max-width: 960px) {
      flex-basis: unset;
    }
  }
  &__filters {
    display: flex;
    margin: 0 -20px;
    align-items: center;
    .cmf-select {
      margin: 0 20px;
    }
    @media screen and (max-width: 960px) {
      margin: 30px 0 0;
      justify-content: space-between;
      flex-wrap: wrap;
      .cmf-select {
        margin: 0;
      }
    }
  }
}
</style>
